import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { useDeliveryOrderBatchesWithoutDeliveries, useUsers } from './apiHooks';
import Loader from '../../components/loader';
import AdminRouteOptimisationDeliveryOrderBatchTable from './adminRoutePlanDeliveryOrderBatchTable';
import Helmet from 'react-helmet';

const AdminRoutePlanBatchesWithoutDeliveries = ({ selectedDeliveryDay }) => {
  const { deliveryOrderBatches, isLoading: loadingDeliveryOrderBatches } = useDeliveryOrderBatchesWithoutDeliveries({
    deliveryDayId: selectedDeliveryDay.id,
  });
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.route.planning.batches.without.deliveries' })}</title>
      </Helmet>
      <h3 className="m-b-3">
        <FormattedMessage id={'admin.route.planning.batches.without.deliveries'} />
      </h3>

      <Loader show={loadingDeliveryOrderBatches} />

      {deliveryOrderBatches && deliveryOrderBatches.length ? (
        <AdminRouteOptimisationDeliveryOrderBatchTable deliveryOrderBatches={deliveryOrderBatches} />
      ) : !loadingDeliveryOrderBatches ? (
        <p>
          <FormattedMessage id={'admin.route.planning.batches.without.deliveries.no.users'} />
        </p>
      ) : (
        ''
      )}
    </div>
  );
};

export default AdminRoutePlanBatchesWithoutDeliveries;
